export const ROOT_URL = '/';
export const CONNECT_URL = '/connect';
export const SYNC_URL = '/sync';
export const DASHBOARD_URL = '/dashboard';
export const SETTINGS_URL = `${DASHBOARD_URL}/settings`;
export const ACTIVITY_URL = (id) => `${DASHBOARD_URL}/activity/${id}`;